import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	buttonLabel: {
		id: 'issue-archival-archives.manage-bars.unarchive-issues.button-label',
		defaultMessage: 'Restore',
		description: 'Button label to unarchive selected issues',
	},
	issueUnarchivalSuccessFlagTitleViewIssue: {
		id: 'issue-archival-archives.manage-bars.unarchive-issues.issue-unarchival-success-flag-title-view-issue',
		defaultMessage: 'View issue',
		description: 'Link to view the restored issue',
	},
	issueUnarchivalErrorFlagTitle: {
		id: 'issue-archival-archives.manage-bars.unarchive-issues.issue-unarchival-error-flag-title',
		defaultMessage:
			'Something went wrong at our end. We couldn’t restore the issues. Refresh and try again.',
		description: 'Header content of the issue unarchival error flag',
	},
	issueUnarchivalSuccessFlagTitle: {
		id: 'issue-archival-archives.manage-bars.unarchive-issues.issue-unarchival-success-flag-title',
		defaultMessage: 'The issue ({issueKey}) has been restored.',
		description: 'Header content of the issue unarchival error flag',
	},
	issueUnarchivalSuccessFlagTitleForMultipleIssues: {
		id: 'issue-archival-archives.manage-bars.unarchive-issues.issue-unarchival-success-flag-title-for-multiple-issues',
		defaultMessage: 'The selected issues have been restored.',
		description:
			'Header content of the issue unarchival error flag when multiple issues are restored',
	},
});
